import api from "./core";

const basePath = "api/core/Emar";

export default {
    query(patientId, from = null, to = null, extraHeaders = {}) {
      let url = `${basePath}/${patientId}/vitals`;
      const params = new URLSearchParams();
      
      if (from) {
        params.append('from', from);
      }
      
      if (to) {
        params.append('to', to);
      }
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      return api.post(url, extraHeaders);
    },
    getEmarLoginUrl(){
      return api.post(`${basePath}/auth`);
    }
};

